// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H16V3H22V17H14V16H4V22H2V2ZM16 5V15H18V5H16Z"}}]};

const Flag4FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-4-filled',
    ref,
    icon: element,
  },
));

Flag4FilledIcon.displayName = 'Flag4FilledIcon';

export default Flag4FilledIcon;
